import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";
import {
  ENROLMENT_STEP,
  ENROLMENT_STEP_STATUS,
} from "@contexts/EnrolmentStatusContext";
import { useEnrolmentStatusContext } from "@contexts/EnrolmentStatusContext";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  questionsErrorNextStep: ENROLMENT_STEP | null;
  setQuestionsErrorNextStep: (step: ENROLMENT_STEP | null) => void;
  questionsErrorNextStepStatus: ENROLMENT_STEP_STATUS | null;
  setQuestionsErrorNextStepStatus: (
    status: ENROLMENT_STEP_STATUS | null,
  ) => void;
}

export const ActionBlockModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
  questionsErrorNextStep,
  setQuestionsErrorNextStep,
  questionsErrorNextStepStatus,
  setQuestionsErrorNextStepStatus,
}) => {
  const navigate = useNavigate();
  const { setCurrentStep, setCurrentStepStatus, getEnrolmentStatus } =
    useEnrolmentStatusContext();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate("/app/solicitudes");
  }, [onClose, navigate]);

  const handleTryAnotherMethod = useCallback(async () => {
    if (questionsErrorNextStep && questionsErrorNextStepStatus) {
      setCurrentStep(questionsErrorNextStep);
      setCurrentStepStatus(questionsErrorNextStepStatus);
      setQuestionsErrorNextStep(null);
      setQuestionsErrorNextStepStatus(null);
    } else {
      await getEnrolmentStatus();
    }

    onClose();
  }, [
    onClose,
    questionsErrorNextStep,
    questionsErrorNextStepStatus,
    getEnrolmentStatus,
    setCurrentStep,
    setCurrentStepStatus,
    setQuestionsErrorNextStep,
    setQuestionsErrorNextStepStatus,
  ]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleTryAnotherMethod}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Probar otro método",
        onClick: handleTryAnotherMethod,
      }}
    />
  );
};
